import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getBrands, IGetBrandsParams } from '../../../../api/brand/queries/getBrands';
import { IBrand } from '../../../../interfaces/Brand.interfaces';

interface IUseGetBrandsQueryParams extends IGetBrandsParams {
  options?: UseQueryOptions<IBrand[], AxiosError>;
}

export const useGetBrandsQuery = ({ searchParam, options }: IUseGetBrandsQueryParams) => {
  return useQuery<IBrand[], AxiosError>(
    ['brands', searchParam.applicableMachineType],
    () => getBrands({ searchParam }),
    {
      ...options,
      staleTime: 5 * 60 * 1000, // 5분간 캐시 유지 (5분에 1번만 요청)
      select: (brands) => {
        const orderedBrandsByImportance = [
          '존디어',
          '뉴홀랜드',
          '구보다',
          '얀마',
          '대동',
          'TYM(국제)',
          'TYM(동양)',
          'LS',
        ];

        const sortedBrands = brands.sort((a, b) => {
          const indexA = orderedBrandsByImportance.indexOf(a.name);
          const indexB = orderedBrandsByImportance.indexOf(b.name);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
          }

          if (indexA !== -1) {
            return -1;
          }

          if (indexB !== -1) {
            return 1;
          }

          return a.name.localeCompare(b.name);
        });

        return sortedBrands;
      },
    },
  );
};
